module.exports = __webpack_public_path__ + "static/media/Pin_TireInstall.074cba7e.svg";